import styled from 'styled-components'

const primaryColor = props => props.theme?.solidColor || '#1890FF'

export const LauncherButton = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background: ${primaryColor};
  color: #fff;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
  z-index: 1000;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.22);
  }

  &:active {
    transform: translateY(0);
  }

  &:focus-visible {
    outline: 2px solid ${primaryColor};
    outline-offset: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const PanelWrapper = styled.div`
  position: fixed;
  bottom: 96px;
  right: 24px;
  width: 380px;
  height: 560px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 160px);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  z-index: 1001;
  flex-direction: column;

  &.chatbot-widget-resizing {
    user-select: none;

    iframe {
      pointer-events: none;
    }
  }
`

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px 10px 38px;
  background: ${primaryColor};
  color: #fff;
  font-weight: 500;
  font-size: 14px;

  .chatbot-close {
    background: transparent;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 18px;
    min-width: 32px;
    min-height: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
    }

    &:focus-visible {
      background: rgba(255, 255, 255, 0.25);
      outline: 2px solid #fff;
      outline-offset: -2px;
    }
  }
`

export const TabList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  flex-shrink: 0;
  border-bottom: 1px solid #edf0f5;
  background: #fff;

  .chatbot-tab {
    min-width: 0;
    height: 44px;
    padding: 0 10px;
    border: none;
    border-bottom: 2px solid transparent;
    background: transparent;
    color: rgba(0, 0, 0, 0.62);
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    white-space: normal;
    word-break: break-word;

    &:hover {
      color: ${primaryColor};
      background: rgba(24, 144, 255, 0.06);
    }

    &:focus-visible {
      outline: 2px solid ${primaryColor};
      outline-offset: -2px;
    }

    &.chatbot-tab-active {
      color: ${primaryColor};
      border-bottom-color: ${primaryColor};
      background: rgba(24, 144, 255, 0.08);
    }
  }
`

export const ResizeHandle = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: nwse-resize;
  padding: 0;
  z-index: 2;
  touch-action: none;

  &::before,
  &::after {
    content: '';
    position: absolute;
    border-top: 2px solid rgba(255, 255, 255, 0.85);
    border-left: 2px solid rgba(255, 255, 255, 0.85);
    border-radius: 1px 0 0 0;
  }

  &::before {
    top: 9px;
    left: 9px;
    width: 12px;
    height: 12px;
  }

  &::after {
    top: 15px;
    left: 15px;
    width: 7px;
    height: 7px;
  }

  &:hover,
  &:focus-visible {
    background: rgba(255, 255, 255, 0.16);
    outline: none;
  }
`

export const IframeContainer = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }

  iframe.chatbot-iframe-loading {
    opacity: 0;
    pointer-events: none;
  }
`

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: #fff;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  text-align: center;
  padding: 24px;

  .chatbot-loading-spinner {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 3px solid rgba(0, 0, 0, 0.12);
    border-top-color: ${primaryColor};
    animation: chatbot-loading-spin 0.8s linear infinite;
  }

  @keyframes chatbot-loading-spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .chatbot-loading-spinner {
      animation: none;
    }
  }
`
